export type TValidStudentPathStatuses =
  | 'Default'
  | 'CLOSED'
  | 'DELETED'
  | 'Accepted'
  | 'Accepted w. special opportunity'
  | 'Accepted w. conditions'
  | 'Plans to apply'
  | 'Plans to defer'
  | 'Committed'
  | 'Committed w. special opportunity'
  | 'Waitlisted'
  | 'Denied'
  | 'Applied'
  | 'Applied w. special opportunity';

export type TValidStudentPathAppliedStatus =
  | 'Accepted'
  | 'Accepted w. special opportunity'
  | 'Accepted w. conditions'
  | 'Committed'
  | 'Committed w. special opportunity'
  | 'Waitlisted'
  | 'Denied'
  | 'Applied'
  | 'Applied w. special opportunity';

export type TValidStudentPathResponseStatus =
  | 'Accepted'
  | 'Accepted w. special opportunity'
  | 'Accepted w. conditions'
  | 'Committed'
  | 'Committed w. special opportunity'
  | 'Waitlisted'
  | 'Denied';

export type TValidStudentPathAcceptedStatus =
  | 'Accepted'
  | 'Accepted w. special opportunity'
  | 'Accepted w. conditions'
  | 'Committed'
  | 'Committed w. special opportunity';

export type TValidStudentPathFinalDecisionStatus = 'Committed' | 'Committed w. special opportunity';

export type TValidStudentPathCommittedStatus = 'Committed' | 'Committed w. special opportunity';

export const FINAL_DECISION_STATUSES: TValidStudentPathFinalDecisionStatus[] = [
  'Committed',
  'Committed w. special opportunity',
];

export const VALID_PATH_STATUSES: TValidStudentPathStatuses[] = [
  'Accepted',
  'Accepted w. special opportunity',
  'Accepted w. conditions',
  'Plans to apply',
  'Plans to defer',
  'Waitlisted',
  'Denied',
  'Applied',
  'Applied w. special opportunity',
  'Committed',
  'Committed w. special opportunity',
];
